import APIhelper from "./components/APIhelper";

export const sendGlamLABVisited = (hUId) => {
  APIhelper.postNftActivity(hUId, "V");
};

export const sendWentToCategory = (hUId, category) => {
  APIhelper.postNftActivity(hUId, "ET");
};

export const sendSkuTried = (hUId, sku) => {
  APIhelper.postNftActivity(hUId, "ST", sku);
}
